import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { cloudinaryAsset } from '../config/media';

const asset = (folder, filename) => cloudinaryAsset(`/home/${folder}/${filename}`);

const heroSlides = [
  'cartel de obra.png',
  'exhibidor cofler.png',
  'exhibidores.png',
  'phibro.png',
  'sedal lali.png',
  'smartfit.png'
].map((filename) => asset('1.1 Hero', filename));

const solutions = [
  {
    key: 'displays',
    image: 'Exhibidores.png',
    to: '/servicios/carteleria#exhibidores'
  },
  {
    key: 'stands',
    image: 'Stand.png',
    to: '/diseno-fabricacion-stands'
  },
  {
    key: 'equipment',
    image: 'Equipamiento para stands.jpg',
    to: '/diseno-fabricacion-stands'
  },
  {
    key: 'signage',
    image: 'Carteleria.png',
    to: '/servicios/carteleria#carteleria'
  },
  {
    key: 'promotional',
    image: 'Mat. Promocional.png',
    to: '/servicios/carteleria#punto-de-venta'
  }
];

const processSteps = [
  {
    number: '01',
    key: 'survey',
    image: 'Paso 1.png'
  },
  {
    number: '02',
    key: 'design',
    image: 'Paso 2.png'
  },
  {
    number: '03',
    key: 'production',
    image: 'Paso 3.png'
  },
  {
    number: '04',
    key: 'installation',
    image: 'Paso 4.png'
  }
];

const Inicio = () => {
  const { t } = useTranslation();
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % heroSlides.length);
    }, 6000);

    return () => window.clearInterval(timer);
  }, []);

  const changeSlide = (direction) => {
    setActiveSlide((current) => (current + direction + heroSlides.length) % heroSlides.length);
  };

  return (
    <main id="inicio" className="home-page">
      <section className="home-hero" style={{ backgroundImage: `linear-gradient(90deg, rgba(4, 23, 49, .88) 0%, rgba(5, 31, 66, .62) 44%, rgba(5, 31, 66, .08) 100%), url("${heroSlides[activeSlide]}")` }}>
        <Container>
          <div className="home-hero-copy">
            <p className="home-eyebrow">Exhibirte Uruguay</p>
            <h1>{t('homeRedesign.hero.title')}</h1>
            <p><Trans i18nKey="homeRedesign.hero.description" components={{ strong: <strong /> }} /></p>
            <div className="home-hero-actions">
              <Link to="/contacto" className="home-primary-link">{t('homeRedesign.hero.contact')} <FaArrowRight aria-hidden="true" /></Link>
              <Link to="/proyectos" className="home-secondary-link">{t('homeRedesign.hero.projects')}</Link>
            </div>
          </div>
        </Container>
        <button className="home-hero-control previous" type="button" onClick={() => changeSlide(-1)} aria-label={t('homeRedesign.previousImage')}><FaArrowLeft /></button>
        <button className="home-hero-control next" type="button" onClick={() => changeSlide(1)} aria-label={t('homeRedesign.nextImage')}><FaArrowRight /></button>
        <div className="home-hero-indicators" role="tablist" aria-label={t('homeRedesign.featuredProjects')}>
          {heroSlides.map((_, index) => (
            <button
              type="button"
              key={index}
              className={index === activeSlide ? 'is-active' : ''}
              onClick={() => setActiveSlide(index)}
              aria-label={t('homeRedesign.viewImage', { number: index + 1 })}
              aria-selected={index === activeSlide}
              role="tab"
            />
          ))}
        </div>
      </section>

      <section className="home-solutions">
        <Container>
          <div className="home-section-heading">
            <p className="home-eyebrow">{t('homeRedesign.solutionsEyebrow')}</p>
            <h2>{t('homeRedesign.solutionsTitle')}</h2>
            <p>{t('homeRedesign.solutionsDescription')}</p>
          </div>
          <div className="home-solutions-grid">
            {solutions.map(({ key, image, to }) => (
              <article className="home-solution-card" key={key}>
                <img src={asset('1.2 Soluciones principales', image)} alt={t(`homeRedesign.solutions.${key}.title`)} loading="lazy" />
                <div className="home-solution-card-content">
                  <h3>{t(`homeRedesign.solutions.${key}.title`)}</h3>
                  <p>{t(`homeRedesign.solutions.${key}.description`)}</p>
                  <Link to={to}>{t('homeRedesign.learnSolution')} <FaArrowRight aria-hidden="true" /></Link>
                </div>
              </article>
            ))}
          </div>
        </Container>
      </section>

      <section className="home-process">
        <Container>
          <div className="home-section-heading">
            <p className="home-eyebrow">{t('homeRedesign.processEyebrow')}</p>
            <h2>{t('homeRedesign.processTitle')}</h2>
            <p>{t('homeRedesign.processDescription')}</p>
          </div>
          <div className="home-process-grid">
            {processSteps.map(({ number, key, image }) => (
              <article className="home-process-step" key={number}>
                <span>{number}</span>
                <img src={asset('1.4 Proceso de trabajo', image)} alt="" loading="lazy" />
                <h3>{t(`homeRedesign.process.${key}.title`)}</h3>
                <p>{t(`homeRedesign.process.${key}.description`)}</p>
              </article>
            ))}
          </div>
        </Container>
      </section>

      <section className="home-about">
        <div className="home-about-grid">
          <img src={asset('1.5 Sobre nosotros', 'Sobre nosotros.jpg')} alt={t('homeRedesign.about.imageAlt')} loading="lazy" />
          <div className="home-about-copy">
            <p className="home-eyebrow">Exhibirte</p>
            <h2>{t('homeRedesign.about.title')}</h2>
            <h3>{t('homeRedesign.about.subtitle')}</h3>
            <p>{t('homeRedesign.about.paragraph1')}</p>
            <p>{t('homeRedesign.about.paragraph2')}</p>
            <Link to="/nosotros" className="home-primary-link">{t('homeRedesign.about.link')} <FaArrowRight aria-hidden="true" /></Link>
          </div>
        </div>
      </section>

      <section className="home-final-cta">
        <Container>
          <div>
            <h2>{t('homeRedesign.cta.title')}</h2>
            <p>{t('homeRedesign.cta.description')}</p>
          </div>
          <Link to="/contacto" className="home-cta-light-link">{t('homeRedesign.cta.link')} <FaArrowRight aria-hidden="true" /></Link>
        </Container>
      </section>
    </main>
  );
};

export default Inicio;

